module.exports = __webpack_public_path__ + "static/media/product-marketing.e3363f4b.svg";